var AdUnit = require('./ad-unit');

/**
 * generates a unique alpha numeric string
 * @returns {string}
 * @private
 */
function _generateId() {
    return (Math.ceil(Math.random() * Math.random() * Math.random() * Date.now() * 1e6)).toString();
}

var AdUnitFactory = function() {

    /**
     *
     * Get new instance of adUnit and return it
     * @param {String} name the ad name such as mrect, leaderc, etc
     * @param {Array} size an array of array sizes such as [[300,250], [300,600]]
     * @param {Function} update function that is called before targeting values are generated.
     * @returns {Object}
     */
    this.createAdUnit = function(refreshZones, getCustomValues, correlator, getModuleValue) {
        var adUnit = new AdUnit(_generateId(), refreshZones, getCustomValues, correlator, getModuleValue);
        adUnit.retarget();
        return adUnit;
    };
};

module.exports = new AdUnitFactory();



//////////////////
// WEBPACK FOOTER
// ./src/interlock/product/ads/ad-unit-factory/ad-unit-factory.js
// module id = 263
// module chunks = 36